import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useDispatch, useSelector } from "react-redux";

import { ClassElement, OverViewTable, Progress } from "./";
import { Header } from "../../Shared";
import { setOverviewTabIndex } from "../../../store/markingSlice";
import { setSelect } from "../../../store/stylesSlice";
import { Common, NavigationBar } from "../../../helper"

import "../../../assets/stlyes/SubjectOverView/SubjectOverViewTabs.scss";
import "../../../assets/stlyes/SubjectOverView/SubjectOverView.scss";
import "bootstrap/dist/css/bootstrap.min.css";

const SubjectOverViewTabs = () => {
  const dispatch = useDispatch();
  const markingData = useSelector((state) => state.marking);
  const tabIndex = useSelector((state) => state.marking.overviewTabIndex);
  const [show, setShow] = useState(false);
  const [ind, setInd] = useState(0);
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed);

  useEffect(() => {
    setInd(ind);
    dispatch(setSelect(NavigationBar.MyClasses))
  }, [ind]);

  return (
    <div className="Page-layout">
      <div className="Page-header" style={{ paddingBottom: "20px" }}>
        <Header />
        <div className="overview-main">
          <ClassElement show={show} markingData={markingData} />
          <Tabs>
            <div className="d-flex">
              <TabList className="subjectOverviewTab-marking-tablist" style={{ marginTop: "126px" }}>
                <Tab className={tabIndex === 0 ? "react-tabs__tab--selected" : "subjectOverviewTab-marking-tabs"} onClick={() => { setShow(false); dispatch(setOverviewTabIndex(0)) }}>{Common.Overall} {markingData.subjectName}{Common.Progress}</Tab>
                <Tab className={tabIndex !== 1 ? "subjectOverviewTab-marking-tabs" : "react-tabs__tab--selected"} onClick={() => { setShow(true); dispatch(setOverviewTabIndex(1)) }}>{Common.SubjectAreaProgress}</Tab>
              </TabList>
              {show &&
                <>
                  <div className="dot-with-text">
                    <div className="highest-dot"></div>
                    <span className="text-HighAndLow"> {Common.Highest}</span>
                    <div className="lowest-dot"></div>
                    <span className="text-HighAndLow"> {Common.Lowest}</span>
                  </div>
                </>
              }
            </div>
            <TabPanel itemID={tabIndex} className="Tabpanels" style={isNavCollapsed ? { paddingRight: "0px" } : { paddingRight: "180px" }} >
              {tabIndex === 0 ? <Progress /> : <OverViewTable />}
            </TabPanel>
            <TabPanel itemID={tabIndex} className="Tabpanels" style={isNavCollapsed ? { paddingRight: "0px" } : { paddingRight: "180px" }} >
              {tabIndex === 1 ? <OverViewTable /> : <Progress />}
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </div>
  );
}

export { SubjectOverViewTabs };
